import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useAvailabilityFinderAccess = () => {
  const [isAvailabilityFinderWetagEnabled, isLoadingAvailabilityFinderWetag] = ScheduleOrg.useWetag(
    'availability-visualization-v3'
  );

  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  return {
    isAvailabilityFinderEnabled: isAvailabilityFinderWetagEnabled && isScheduleV3FlagEnabled,
    isLoadingAvailabilityFinderTag: isLoadingAvailabilityFinderWetag,
  };
};
